import { type QueryHookOptions, useQuery } from "@apollo/client";
import { AnalyticsVisitorsByDateQuery } from "../graphql/queries";
import type {
  AnalyticsVisitorsByDateQueryType,
  AnalyticsVisitorsByDateQueryVariablesType,
} from "@/types/graphql/partner.generated";

export const useAnalyticsVisitorsByDateQuery = (
  options?: QueryHookOptions<
    AnalyticsVisitorsByDateQueryType,
    AnalyticsVisitorsByDateQueryVariablesType
  >
) => {
  return useQuery<
    AnalyticsVisitorsByDateQueryType,
    AnalyticsVisitorsByDateQueryVariablesType
  >(AnalyticsVisitorsByDateQuery, options);
};
